module.exports = __webpack_public_path__ + "img/logo-nap.a18f1839.svg";